// extracted by mini-css-extract-plugin
module.exports = {"container":"error_container__28vu6","content":"error_content__1q3B3","header":"error_header__3-p8Z","info":"error_info__GOpwr","button_container":"error_button_container__i69hG"};